import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { TestPage } from './test/test.page';
import {AddfriendPage} from './addfriend/addfriend.page';
import{GamingcontrollerPage} from './gamingcontroller/gamingcontroller.page';
import { LoginPage } from './login/login.page';
import { RegisterPage } from './register/register.page';
import { HomePage } from './home/home.page';
import{AppLayoutPage} from './_layout/app-layout/app-layout.page';
import{ ProfilePage} from './profile/profile.page';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  { path: 'test', component: TestPage },
  { path: 'home', component: HomePage },
  { path: 'addfriend', component: AddfriendPage },
  { path: 'gamecontroller', component: GamingcontrollerPage },
  { path: 'login', component: LoginPage },
  { path: 'register', component: RegisterPage },
  { path: 'profile', component: ProfilePage },

  {
    path: 'app-layout',
    loadChildren: () => import('./_layout/app-layout/app-layout.module').then( m => m.AppLayoutPageModule)
  },
  {
    path: 'login-layout',
    loadChildren: () => import('./_layout/login-layout/login-layout.module').then( m => m.LoginLayoutPageModule)
  },
  
 
  

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routing = RouterModule.forRoot(routes);
